import { deleteLocalSelectedOU, useQuery } from '@monorepo/shared';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Loader } from 'rsuite';
import { t } from 'i18next';

export const LoginRedirect = () => {
  let query = useQuery();
  const { state } = useLocation();
  const navigate = useNavigate();
  const debug_key = query.get('debug_key') || state?.debug_key;
  const redirect_data = query.get('redirect_data') || '';

  useEffect(() => {
    if (redirect_data) {
      navigate('/organization', {
        state: {
          debug_key: debug_key,
          redirect_data
        }
      });
    } else {
      deleteLocalSelectedOU();
      navigate('/cred/ou', {
        state: {
          debug_key: debug_key
        }
      });
    }
  }, [redirect_data]);
  return (
    <>
      <Loader center content={t('common.loading')} />
    </>
  );
};
